import React from 'react';
import ReactDOM from 'react-dom/client';
import { Analytics } from '@vercel/analytics/react';
import { AuthProvider } from '@/app/providers/AuthProvider';
import { ToastProvider } from '@/app/providers/ToastProvider';
import { initSentry } from '@/lib/sentry';
import App from '@/app/App';
import '@/shared/responsive.css';

initSentry();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <ToastProvider>
        <App />
        <Analytics />
      </ToastProvider>
    </AuthProvider>
  </React.StrictMode>
);
